import Lang from "lang.js";

var translations = {};
const translationFiles = import.meta.glob("../../lang/*.json", {
    eager: true,
});

for (const key in translationFiles) {
    const content = translationFiles[key].default;
    const fileName = key.split("lang/")[1].split(".json")[0];
    translations[fileName] = content;
}

const lang = new Lang({
    messages: translations,
    locale: "sv",
    fallback: "en",
});

Lang.prototype._getMessage = function (key, locale) {
    locale = locale || this.getLocale();

    if (!this.messages[locale]) {
        locale = this.getFallback();
        if (!this.messages[locale]) {
            return key;
        }
    }
    if (!this.messages[locale][key]) {
        locale = this.getFallback();
        if (!this.messages[locale] || !this.messages[locale][key]) {
            return key;
        }
    }
    return this.messages[locale][key];
};

Lang.prototype.get = function (key, replacements, locale) {
    var message = this._getMessage(key, locale);

    if (message == null) {
        message = key;
    }
    if (replacements) {
        message = this._applyReplacements(message, replacements);
    }

    return message;
};

export default lang;
